import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import api from "../../api";
import Success from "components/Typography/Success";
import TimeSeries1 from "../TimeS";
import { Grid, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: { flexGrow: 1, margin: 0, padding: 0, width: "100%" },
  paper: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    padding: theme.spacing(1),
    textAlign: "center",
    borderRadius: "6px",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa",
    opacity: "1",
  },
  formControl: { autosize: true, clearable: false },
  select: {
    "&:after": { borderBottomColor: "blue" },
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor: "#0123b4",
      borderRadius: "8px",
    },
  },
  headingFont: {
    "@media (min-width:0px) and (max-width:599.95px)": { textAlign: "center", fontSize: "1.5vh", color: "black" },
    "@media (min-width:600px) and (max-width:959.95px)": { textAlign: "center", fontSize: "1.6vh", color: "black" },
    "@media (min-width:960px) and (max-width:1279.95px)": { textAlign: "center", fontSize: "1.5vh", color: "black" },
    "@media (min-width:1280px) and (max-width:1919.95px)": { textAlign: "center", fontSize: "1.8vh", whiteSpace: "nowrap", color: "black" },
    "@media (min-width:1920px) and (max-width:2559.95px)": { textAlign: "center", fontSize: "1.8vh", color: "black", whiteSpace: "nowrap" },
  },
  statusFont: {
    "@media (min-width:0px) and (max-width:599.95px)": { textAlign: "center", fontSize: "3.3vh", color: "black" },
    "@media (min-width:600px) and (max-width:959.95px)": { textAlign: "center", fontSize: "3.5vh", color: "black" },
    "@media (min-width:960px) and (max-width:1279.95px)": { textAlign: "center", fontSize: "2.7vh", color: "black" },
    "@media (min-width:1280px) and (max-width:1919.95px)": { textAlign: "center", fontSize: "3.5vh", whiteSpace: "nowrap", color: "black" },
    "@media (min-width:1920px) and (max-width:2559.95px)": { textAlign: "center", fontSize: "3.3vh", color: "black", whiteSpace: "nowrap" },
  },
  graphpaper: {
    height: "29vh",
    padding: theme.spacing(1),
    textAlign: "center",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa",
    opacity: "1",
    borderRadius: "14px",
  },
}));

// ─── Parameter arrays ─────────────────────────────────────────────────────────

const POWER_CONSUMPTION_PARAMS = [
  "DG_EM_Metering_WH", "EM_TR_WH", "EM_LIFT_RM_WH",
  "EM_Light_Power_Schnider_Meter_Kwh", "EM_SDB_Emergency_Schnider_kwh",
  "EM_CAR_Charger_WH", "EM_UPS_WH", "EM_UPS_Schnider_Meter_1_KWH",
  "EM_LT_PANEL_WH", "EMS_VRB_KWH", "EM_Firefighting_Kwh",
];

const LOAD_KW_PARAMS = [
  "DG_EM_Load", "DG_EM_WATT", "EM_CAR_Charger_WATT", "EM_Lift_WATT",
  "EM_Light_Power_Schnider_kw", "EM_SDB_Emergency_Schnider_kw",
  "EM_UPS_Watt", "EM_UPS_Schnider_kw", "EM_LT_WATT", "EM_TR_Watt",
  "EMS_VRB_KW", "EM_Firefighting_kw",
];

const PF_PARAMS = [
  "DG_EM_Power_Factor", "DG_EM_AV_PF", "EM_Light_Power_Schnider_PF",
  "EM_SDB_Emergency_Schnider_PF", "EM_CAR_Charger_AV_PF",
  "EM_UPS_AV_PF", "EM_UPS_Schnider_PF", "EM_LT_AV_PF",
  "EM_Lift_AV_PF", "EM_TR_AV_PF", "EMS_VRB_PF", "EM_Firefighting_PF",
];

const FREQ_PARAMS = [
  "DG_EM_Frequency", "DG_EM_Metering_Freq", "EM_TR_Freq", "EM_LIFT_RM_Freq",
  "EM_Light_Power_Schnider_meter_Freq", "EM_SDB_Emergency_Schnider_meter_FREQ",
  "EM_CAR_Charger_Freq", "EM_UPS_Freq", "EM_LT_PANEL_Freq",
  "EMS_VRB_FREQ", "EM_Firefighting_Freq",
];

const VOLT_R_PARAMS = [
  "EM_Light_Power_Schnider_meter_phase_volt_R_B",
  "EM_SDB_Emergency_Schnider_meteR_phase_volt_R_Y",
  "EM_CAR_Charger_V_R_PHASE", "EM_UPS_V_R_PHASE",
  "EM_UPS_Schnider_meter_phase_volt_R_Y", "EM_UPS_Schnider_meter_phase_curent_R", "EMS_VRB_Volt_Phase_R",
  "DG_EM_Metering_R_Phase", "EM_LT_PANEL_R_PHASE",
  "EM_LIFT_RM_R_Phase", "EM_TR_R_Phase", "EM_Firefighting_phase_volt_RB",
];


const VOLT_Y_PARAMS = [
  "EM_Light_Power_Schnider_meter_phase_volt_R_Y",
  "EM_SDB_Emergency_Schnider_meter_phase_volt_Y_B",
  "EM_CAR_Charger_V_Y_PHASE", "EM_UPS_V_Y_PHASE",
  "EM_UPS_Schnider_meter_phase_volt_Y_B", "EMS_VRB_Volt_Phase_Y",
  "DG_EM_Metering_Y_Phase", "EM_LT_PANEL_Y_PHASE",
  "EM_LIFT_RM_Y_Phase", "EM_TR_Y_Phase", "EM_Firefighting_phase_volt_RY", "EM_UPS_Schnider_meter_phase_curent_Y"
];

const VOLT_B_PARAMS = [
  "EM_Light_Power_Schnider_meter_phase_volt_Y_B",
  "EM_CAR_Charger_V_B_PHASE", "EM_UPS_V_B_PHASE",
  "EM_UPS_Schnider_meter_phase_volt_R_B", "DG_EM_Metering_B_Phase",
  "EM_LT_PANEL_B_PHASE", "EM_LIFT_RM_B_Phase", "EM_TR_B_Phase",
  "EM_SDB_Emergency_Schnider_meter_phase_volt_R_B",
  "EMS_VRB_Volt_Phase_B", "EM_Firefighting_phase_volt_YB", "EM_UPS_Schnider_meter_phase_curent_B"
];

const CUR_R_PARAMS = [
  "DG_EM_Current_R_Phase", "EM_TR_Current_R_Phase", "EM_Lift_Current_R_Phase",
  "EM_Light_Power_Schnider_meter_phase_curent_R",
  "EM_SDB_Emergency_Schnider_meter_phase_curent_R",
  "EM_CAR_Charger_Current_R_Phase", "EM_UPS_Current_R_Phase",
  "EM_LT_Current_R_Phase", "EMS_VRB_Current_R_Phase",
  "EM_Firefighting_phase_curent_R",
];

const CUR_Y_PARAMS = [
  "DG_EM_Current_Y_Phase", "EM_TR_Current_Y_Phase", "EM_Lift_Current_Y_Phase",
  "EM_Light_Power_Schnider_meter_phase_curent_Y",
  "EM_SDB_Emergency_Schnider_meter_phase_curent_Y",
  "EM_CAR_Charger_Current_Y_Phase", "EM_UPS_Current_Y_PHASE",
  "EM_LT_Current_Y_Phase", "EMS_VRB_Current_Y_Phase",
  "EM_Firefighting_phase_curent_Y",
];

const CUR_B_PARAMS = [
  "DG_EM_Current_B_Phase", "EM_TR_Current_B_Phase", "EM_Lift_Current_B_Phase",
  "EM_Light_Power_Schnider_meter_phase_curent_B",
  "EM_SDB_Emergency_Schnider_meter_phase_curent_B",
  "EM_CAR_Charger_Current_B_Phase", "EM_UPS_Current_B_Phase",
  "EM_LT_Current_B_Phase", "EMS_VRB_Current_B_Phase",
  "EM_Firefighting_phase_curent_B",
];

const EMPTY_GRAPH = {
  llphase1: [], llphase2: [], llphase3: [],
  currentphase1: [], currentphase2: [], currentphase3: [],
  powerfactorGraph: [], loadGraph: [], freqGraph: [], powerConsumptionGraph: [],
};

// ─── Fallback device type ─────────────────────────────────────────────────────
const FALLBACK_DEVICE_TYPE = "NONGL_SS_EMS";
const TIME_RANGE = "1 Week";
const REQUEST_BODY = { startdate: "start", enddate: "end" };

// ─── Helper: extract device type from device object ───────────────────────────
// Tries all common field names. Once you confirm the field name from
// console.log, you can simplify this to just d.sstype or d.type etc.
const getDeviceType = (deviceObj) => {
  if (!deviceObj) return FALLBACK_DEVICE_TYPE;
  return (
    deviceObj.sstype ||
    deviceObj.device_type ||
    deviceObj.deviceType ||
    deviceObj.type ||
    FALLBACK_DEVICE_TYPE
  );
};

function GlEnergyMeter(props) {
  const classes = useStyles();

  // ─── Live metric state ───────────────────────────────────────────────────
  const [voltR, setVoltR] = useState(null);
  const [voltY, setVoltY] = useState(null);
  const [voltB, setVoltB] = useState(null);
  const [voltage_ll, setVoltageLL] = useState("");
  const [curR, setCurR] = useState(null);
  const [curY, setCurY] = useState(null);
  const [curB, setCurB] = useState(null);
  const [current, setCurrent] = useState("");
  const [power, setPower] = useState("");
  const [loadKw, setLoadKw] = useState("");
  const [freq, setFreq] = useState("");
  const [powerConsumption, setPowerConsumption] = useState("");

  // ─── Graph state ─────────────────────────────────────────────────────────
  const [graphData, setGraphData] = useState(EMPTY_GRAPH);

  // ─── UI state ────────────────────────────────────────────────────────────
  const [fdata, setFdata] = useState("");
  const [floor, setFloor] = useState([]);
  const [data, setData] = useState(props.location.state?.dev_name || "");
  const [activeEMS, setActiveEMS] = useState(props.location.state?.dev_id || "");

  // ─── Dynamic device type state (NO MORE HARDCODING) ──────────────────────
  const [activeDeviceType, setActiveDeviceType] = useState(
    props.location.state?.device_type
      ? [props.location.state.device_type]
      : [FALLBACK_DEVICE_TYPE]
  );

  const [energydevice, setEnergydevice] = useState([]);
  const [loading, setLoading] = useState(false);

  const initialized = useRef(false);

  const zone_data = useSelector((state) => state.inDashboard.locationData);
  const buildingID = useSelector((state) => state.isLogged.data.building.id);

  const formatter = useMemo(
    () => new Intl.NumberFormat("en-US", { minimumFractionDigits: 1, maximumFractionDigits: 1 }),
    []
  );

  // ─── Average voltage / current from phases ───────────────────────────────
  useEffect(() => {
    console.log("VOLTAGES", { voltR, voltY, voltB, voltage_ll });
    console.log("((voltR + voltY + voltB) / 3).toFixed(2)", ((voltR + voltY + voltB) / 3).toFixed(2));
    if (voltR !== null && voltY !== null && voltB !== null)
      setVoltageLL(((voltR + voltY + voltB) / 3).toFixed(2));

    if (curR !== null && curY !== null && curB !== null)
      setCurrent(((curR + curY + curB) / 3).toFixed(2));
  }, [voltR, voltY, voltB, curR, curY, curB]);

  // ─── Process snapshot ────────────────────────────────────────────────────
  const processSnapshotData = useCallback((res) => {
    if (!res || !Array.isArray(res)) return;
    const findFloat = (fields) => {
      const matches = res.filter((e) => fields.includes(e.param_id));
      if (!matches.length) return null;
      const values = matches
        .map((m) => parseFloat(m.param_value))
        .filter((v) => !isNaN(v));
      if (!values.length) return null;
      return values.reduce((a, b) => a + b, 0) / values.length; // average
    };

    // ── NEW: returns ALL matching raw values joined, or first non-empty ──
    const findRaw = (fields) => {
      const matches = res.filter((e) => fields.includes(e.param_id));
      if (!matches.length) return "";
      // Return first non-empty value
      const found = matches.find((m) => m.param_value !== null && m.param_value !== "");
      return found ? found.param_value : "";
    };

    setVoltR(findFloat(VOLT_R_PARAMS));
    setVoltY(findFloat(VOLT_Y_PARAMS));
    setVoltB(findFloat(VOLT_B_PARAMS));
    setCurR(findFloat(CUR_R_PARAMS));
    setCurY(findFloat(CUR_Y_PARAMS));
    setCurB(findFloat(CUR_B_PARAMS));
    setPower(findRaw(PF_PARAMS));
    setLoadKw(findRaw(LOAD_KW_PARAMS));
    setFreq(findRaw(FREQ_PARAMS));
    setPowerConsumption(findRaw(POWER_CONSUMPTION_PARAMS));
  }, []);

  // ─── Process graph ───────────────────────────────────────────────────────
  const processGraphData = useCallback((res) => {
    if (!res || !res.graphData || !res.graphData.length) {
      setGraphData(EMPTY_GRAPH);
      return;
    }

    const gd = res.graphData[0];
    const pick = (...keys) => {
      const found = keys.find((k) => Array.isArray(gd[k]) && gd[k].length > 0);
      return found ? gd[found] : [];
    };
    setGraphData({
      llphase1: pick("EM_Light_Power_Schnider_meter_phase_volt_R_B", "EM_SDB_Emergency_Schnider_meteR_phase_volt_R_Y", "EM_CAR_Charger_V_R_PHASE", "EM_UPS_V_R_PHASE", "EM_UPS_Schnider_meter_phase_volt_R_Y", "EMS_VRB_Volt_Phase_R", "DG_EM_Metering_R_Phase", "EM_LT_PANEL_R_PHASE", "EM_LIFT_RM_R_Phase", "EM_TR_R_Phase", "EM_Firefighting_phase_volt_RB", "EM_UPS_Schnider_meter_phase_curent_R"),
      llphase2: pick("EM_Light_Power_Schnider_meter_phase_volt_R_Y", "EM_SDB_Emergency_Schnider_meter_phase_volt_Y_B", "EM_CAR_Charger_V_Y_PHASE", "EM_UPS_V_Y_PHASE", "EM_UPS_Schnider_meter_phase_volt_Y_B", "EMS_VRB_Volt_Phase_Y", "DG_EM_Metering_Y_Phase", "EM_LT_PANEL_Y_PHASE", "EM_LIFT_RM_Y_Phase", "EM_TR_Y_Phase", "EM_Firefighting_phase_volt_RY", "EM_UPS_Schnider_meter_phase_curent_Y"),
      llphase3: pick("EM_Light_Power_Schnider_meter_phase_volt_Y_B", "EM_CAR_Charger_V_B_PHASE", "EM_UPS_V_B_PHASE", "EM_UPS_Schnider_meter_phase_volt_R_B", "DG_EM_Metering_B_Phase", "EM_LT_PANEL_B_PHASE", "EM_LIFT_RM_B_Phase", "EM_TR_B_Phase", "EM_SDB_Emergency_Schnider_meter_phase_volt_R_B", "EMS_VRB_Volt_Phase_B", "EM_Firefighting_phase_volt_YB", "EM_UPS_Schnider_meter_phase_curent_B"),
      currentphase1: pick("DG_EM_Current_R_Phase", "EM_TR_Current_R_Phase", "EM_Lift_Current_R_Phase", "EM_Light_Power_Schnider_meter_phase_curent_R", "EM_SDB_Emergency_Schnider_meter_phase_curent_R", "EM_CAR_Charger_Current_R_Phase", "EM_UPS_Current_R_Phase", "EM_LT_Current_R_Phase", "EMS_VRB_Current_R_Phase", "EM_Firefighting_phase_curent_R"),
      currentphase2: pick("DG_EM_Current_Y_Phase", "EM_TR_Current_Y_Phase", "EM_Lift_Current_Y_Phase", "EM_Light_Power_Schnider_meter_phase_curent_Y", "EM_SDB_Emergency_Schnider_meter_phase_curent_Y", "EM_CAR_Charger_Current_Y_Phase", "EM_UPS_Current_Y_PHASE", "EM_LT_Current_Y_Phase", "EMS_VRB_Current_Y_Phase", "EM_Firefighting_phase_curent_Y"),
      currentphase3: pick("DG_EM_Current_B_Phase", "EM_TR_Current_B_Phase", "EM_Lift_Current_B_Phase", "EM_Light_Power_Schnider_meter_phase_curent_B", "EM_SDB_Emergency_Schnider_meter_phase_curent_B", "EM_CAR_Charger_Current_B_Phase", "EM_UPS_Current_B_Phase", "EM_LT_Current_B_Phase", "EMS_VRB_Current_B_Phase", "EM_Firefighting_phase_curent_B"),
      powerfactorGraph: pick("DG_EM_Power_Factor", "DG_EM_AV_PF", "EM_Light_Power_Schnider_PF", "EM_SDB_Emergency_Schnider_PF", "EM_CAR_Charger_AV_PF", "EM_UPS_AV_PF", "EM_UPS_Schnider_PF", "EM_LT_AV_PF", "EM_Lift_AV_PF", "EM_TR_AV_PF", "EMS_VRB_PF", "EM_Firefighting_PF"),
      loadGraph: pick("DG_EM_Load", "DG_EM_WATT", "EM_CAR_Charger_WATT", "EM_Lift_WATT", "EM_Light_Power_Schnider_kw", "EM_SDB_Emergency_Schnider_kw", "EM_UPS_Watt", "EM_UPS_Schnider_kw", "EM_LT_WATT", "EM_TR_Watt", "EMS_VRB_KW", "EM_Firefighting_kw"),
      freqGraph: pick("DG_EM_Frequency", "DG_EM_Metering_Freq", "EM_TR_Freq", "EM_LIFT_RM_Freq", "EM_Light_Power_Schnider_meter_Freq", "EM_SDB_Emergency_Schnider_meter_FREQ", "EM_CAR_Charger_Freq", "EM_UPS_Freq", "EM_LT_PANEL_Freq", "EMS_VRB_FREQ", "EM_Firefighting_Freq"),
      powerConsumptionGraph: pick("DG_EM_Metering_WH", "EM_TR_WH", "EM_LIFT_RM_WH", "EM_Light_Power_Schnider_Meter_Kwh", "EM_SDB_Emergency_Schnider_kwh", "EM_CAR_Charger_WH", "EM_UPS_WH", "EM_UPS_Schnider_Meter_1_KWH", "EM_LT_PANEL_WH", "EMS_VRB_KWH", "EM_Firefighting_Kwh"),
    });
  }, []);

  // ─── Clear metrics ───────────────────────────────────────────────────────
  const clearMetrics = useCallback(() => {
    setVoltR(null); setVoltY(null); setVoltB(null); setVoltageLL("");
    setCurR(null); setCurY(null); setCurB(null); setCurrent("");
    setPower(""); setLoadKw(""); setFreq(""); setPowerConsumption("");
    setGraphData(EMPTY_GRAPH);
  }, []);

  // ─── Load devices for a floor ────────────────────────────────────────────
  const loadDevicesForFloor = useCallback((floorName, floorId, autoSelectFirst = false) => {
    setFdata(floorName);
    setLoading(true);
    api.floor
      .devicemap(floorId, "energyMeter")
      .then((res) => {
        if (!res || res.length === 0) {
          setEnergydevice([]);
          setActiveEMS("");
          setData("");
          clearMetrics();
          return;
        }
        res.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        setEnergydevice(res);

        if (autoSelectFirst) {
          const first = res[0];
          // ── Dynamically pick device type from the device object ──
          const devType = [getDeviceType(first)];
          console.log("Auto-select first device:", first, "devType:", devType);
          setActiveDeviceType(devType);
          setData(first.name);
          setActiveEMS(first.ssid);
          api.floor.EmsData(first.ssid).then(processSnapshotData).catch(() => { });
          api.floor.getDeviceData(REQUEST_BODY, first.ssid, devType, TIME_RANGE)
            .then(processGraphData).catch(() => { });
        }
      })
      .catch(() => {
        setEnergydevice([]);
        setActiveEMS("");
        setData("");
      })
      .finally(() => setLoading(false));
  }, [clearMetrics, processSnapshotData, processGraphData]);

  // ─── Floor dropdown change ────────────────────────────────────────────────
  const handlefloorchange = useCallback((floorName, floorId) => {
    setData("");
    setActiveEMS("");
    clearMetrics();
    loadDevicesForFloor(floorName, floorId, true);
  }, [clearMetrics, loadDevicesForFloor]);

  // ─── Device dropdown change ───────────────────────────────────────────────
  const handleChange = useCallback((name, id, deviceObj) => {
    // ── Dynamically pick device type from the device object ──
    const devType = [getDeviceType(deviceObj)];
    console.log("Device selected:", deviceObj, "devType:", devType);
    setActiveDeviceType(devType);
    setActiveEMS(id);
    setData(name);
    clearMetrics();
    setLoading(true);
    api.floor.EmsData(id).then(processSnapshotData).catch(() => clearMetrics());
    api.floor
      .getDeviceData(REQUEST_BODY, id, devType, TIME_RANGE)
      .then(processGraphData)
      .catch(() => setGraphData(EMPTY_GRAPH))
      .finally(() => setLoading(false));
  }, [processSnapshotData, processGraphData, clearMetrics]);

  // ─── ONE-TIME init effect ─────────────────────────────────────────────────
  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const sortedZones = [...zone_data].sort((a, b) =>
      a.name > b.name ? 1 : b.name > a.name ? -1 : 0
    );
    const floorZones = sortedZones.filter(
      (z) => z.zone_type === "GL_LOCATION_TYPE_FLOOR"
    );

    const PLANTROOM_ID = "2ffc9cf4-f0c6-4299-9961-921a86542bc7";
    api.dashboard
      .getMetricData(buildingID)
      .then((res) => {
        res.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

        const plant = res.find(
          (f) =>
            f.id === PLANTROOM_ID ||
            (f.name && f.name.toLowerCase().includes("plantroom")) ||
            (f.name && f.name.toLowerCase().includes("plant"))
        );

        let floorList;
        let defaultFloor;

        if (plant) {
          floorList = [plant];
          defaultFloor = plant;
        } else {
          floorList = res;
          const firstZoneMatch = floorZones[0]
            ? res.find((f) => f.id === floorZones[0].uuid)
            : null;
          defaultFloor = firstZoneMatch || res[0];
        }

        setFloor(floorList);
        if (!defaultFloor) return;

        const hasPassedDevice = !!props.location.state?.dev_id;

        if (hasPassedDevice) {
          const matchedFloor = floorList.find((f) => f.id === defaultFloor.id) || defaultFloor;
          setFdata(matchedFloor.name);
          loadDevicesForFloor(matchedFloor.name, matchedFloor.id, false);

          const devId = props.location.state.dev_id;
          const devName = props.location.state.dev_name;
          // ── Use device_type passed via navigation state if available ──
          const devType = props.location.state.device_type
            ? [props.location.state.device_type]
            : [FALLBACK_DEVICE_TYPE];
          console.log("Navigation device type:", devType);
          setActiveDeviceType(devType);
          setData(devName || "");
          setActiveEMS(devId);
          api.floor.EmsData(devId).then(processSnapshotData).catch(() => { });
          api.floor.getDeviceData(REQUEST_BODY, devId, devType, TIME_RANGE)
            .then(processGraphData).catch(() => { });
        } else {
          loadDevicesForFloor(defaultFloor.name, defaultFloor.id, true);
        }
      })
      .catch(() => {
        if (floorZones.length > 0) {
          const first = floorZones[0];
          setFloor(floorZones.map((z) => ({ id: z.uuid, name: z.name })));
          loadDevicesForFloor(first.name, first.uuid, true);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ─── Polling effect — uses activeDeviceType (fully dynamic) ──────────────
  useEffect(() => {
    if (!activeEMS) return;
    const timer = setInterval(() => {
      api.floor.EmsData(activeEMS).then(processSnapshotData).catch(() => { });
      api.floor.getDeviceData(REQUEST_BODY, activeEMS, activeDeviceType, TIME_RANGE)
        .then(processGraphData).catch(() => { });
    }, 5000);
    return () => clearInterval(timer);
  }, [activeEMS, activeDeviceType, processSnapshotData, processGraphData]);

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <div className={classes.root} style={{ marginTop: "0%" }}>
      <Grid container xs={12} spacing={2}>
        <Grid container item xs={12} spacing={1}>

          {/* Floor selector */}
          <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
            <FormControl variant="filled" size="large" className={classes.formControl}
              style={{ width: "max-content", minWidth: "100%", backgroundColor: "#eeeef5", fontFamily: "Arial" }}>
              <Select
                labelId="filled-hidden-label-small"
                id="demo-simple-select-outlined"
                label="Floor"
                className={classes.select}
                style={{ fontWeight: "bold", height: "6vh", borderRadius: "0.8vw", fontFamily: "Arial" }}
                value={fdata || ""}
                disableUnderline
                onChange={(e) => {
                  const sel = floor.find((f) => f.name === e.target.value);
                  if (sel) handlefloorchange(sel.name, sel.id);
                }}
              >
                {floor.map((_item) => (
                  <MenuItem key={_item.id} value={_item.name}>{_item.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Device selector */}
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <FormControl variant="filled" size="large" className={classes.formControl}
              style={{ width: "max-content", minWidth: "100%", backgroundColor: "#eeeef5", fontFamily: "Arial" }}>
              <Select
                labelId="filled-hidden-label-small"
                id="demo-simple-select-outlined"
                label="Device"
                className={classes.select}
                style={{ fontWeight: "bold", height: "6vh", borderRadius: "0.8vw", fontFamily: "Arial" }}
                value={data || ""}
                disableUnderline
                onChange={(e) => {
                  const sel = energydevice.find((d) => d.name === e.target.value);
                  console.log("DEVICE OBJECT:", sel); // ← check console to confirm field name
                  if (sel) handleChange(sel.name, sel.ssid, sel); // ← passes full object
                }}
              >
                {energydevice.map((_item) => (
                  <MenuItem key={_item.ssid} value={_item.name}>{_item.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

        </Grid>
      </Grid>

      {/* ── Metric cards ── */}
      <Grid container xs={12} spacing={2}>
        <Grid container item xs={12} spacing={1}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
            <Card className={`${classes.paper}`}>
              <Grid container item xs={12} spacing={1}>

                {/* Voltage */}
                <Grid item xs={6} sm={4} md={3} lg={2} xl={2} xxl={2}>
                  <Card style={{ boxShadow: "inset 0px 0px 0px 2px rgb(76 175 80)", backgroundColor: "#fcfafa", borderRadius: "10px", height: "12vh" }}>
                    <Grid container item xs={12} direction="column" style={{ justifyContent: "center", alignContent: "center", whiteSpace: "nowrap" }}>
                      <Grid container item xs={12} spacing={1} direction="column" alignItems="center" className={classes.headingFont}>
                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1} xxl={1} />
                        <Grid item xs={5} sm={5} md={5} lg={5} xl={5} xxl={5} style={{ display: "flex", justifyContent: "center" }}>Voltage</Grid>
                        <Grid container item xs={12}>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className={classes.statusFont} style={{ display: "flex", justifyContent: "center" }}>
                            {console.log("Rendering voltage_ll:", voltage_ll, " formatted:", formatter.format(voltage_ll))}
                            <Success>{formatter.format(voltage_ll)}V</Success>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                {/* Current */}
                <Grid item xs={6} sm={4} md={3} lg={2} xl={2} xxl={2}>
                  <Card style={{ boxShadow: "inset 0px 0px 0px 2px rgb(76 175 80)", backgroundColor: "#fcfafa", borderRadius: "10px", height: "12vh" }}>
                    <Grid container item xs={12} direction="column" style={{ justifyContent: "center", alignContent: "center", whiteSpace: "nowrap" }}>
                      <Grid container item xs={12} spacing={1} direction="column" alignItems="center" className={classes.headingFont}>
                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1} xxl={1} />
                        <Grid item xs={5} sm={5} md={5} lg={5} xl={5} xxl={5} style={{ display: "flex", justifyContent: "center" }}>Current</Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className={classes.statusFont} style={{ display: "flex", justifyContent: "center" }}>
                          <Success>{formatter.format(current)}A</Success>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                {/* Power Factor */}
                <Grid item xs={6} sm={4} md={3} lg={2} xl={2} xxl={2}>
                  <Card style={{ boxShadow: "inset 0px 0px 0px 2px rgb(76 175 80)", backgroundColor: "#fcfafa", borderRadius: "10px", height: "12vh" }}>
                    <Grid container item xs={12} direction="column" style={{ justifyContent: "center", alignContent: "center", whiteSpace: "nowrap" }}>
                      <Grid container item xs={12} spacing={1} direction="column" alignItems="center" className={classes.headingFont}>
                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1} xxl={1} />
                        <Grid item xs={5} sm={5} md={5} lg={5} xl={5} xxl={5} style={{ display: "flex", justifyContent: "center" }}>Power Factor</Grid>
                        <Grid container item xs={12}>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className={classes.statusFont} style={{ display: "flex", justifyContent: "center" }}>
                            <Success>{formatter.format(power)}</Success>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                {/* Load-KW */}
                <Grid item xs={6} sm={4} md={3} lg={2} xl={2} xxl={2}>
                  <Card style={{ boxShadow: "inset 0px 0px 0px 2px rgb(76 175 80)", backgroundColor: "#fcfafa", borderRadius: "10px", height: "12vh" }}>
                    <Grid container item xs={12} direction="column" style={{ justifyContent: "center", alignContent: "center", whiteSpace: "nowrap" }}>
                      <Grid container item xs={12} spacing={1} direction="column" alignItems="center" className={classes.headingFont}>
                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1} xxl={1} />
                        <Grid item xs={5} sm={5} md={5} lg={5} xl={5} xxl={5} style={{ display: "flex", justifyContent: "center" }}>Load-KW</Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
                          <Grid container item xs={12}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className={classes.statusFont} style={{ display: "flex", justifyContent: "center" }}>
                              <Success>{formatter.format(loadKw)}kW</Success>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                {/* Frequency */}
                <Grid item xs={6} sm={4} md={3} lg={2} xl={2} xxl={2}>
                  <Card style={{ boxShadow: "inset 0px 0px 0px 2px rgb(76 175 80)", backgroundColor: "#fcfafa", borderRadius: "10px", height: "12vh" }}>
                    <Grid container item xs={12} direction="column" style={{ justifyContent: "center", alignContent: "center", whiteSpace: "nowrap" }}>
                      <Grid container item xs={12} spacing={1} direction="column" alignItems="center" className={classes.headingFont}>
                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1} xxl={1} />
                        <Grid item xs={5} sm={5} md={5} lg={5} xl={5} xxl={5} style={{ display: "flex", justifyContent: "center" }}>Frequency</Grid>
                        <Grid container item xs={12}>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className={classes.statusFont} style={{ display: "flex", justifyContent: "center" }}>
                            <Success>{formatter.format(freq)}Hz</Success>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

                {/* Power Consumption */}
                <Grid item xs={6} sm={4} md={3} lg={2} xl={2} xxl={2}>
                  <Card style={{ boxShadow: "inset 0px 0px 0px 2px rgb(76 175 80)", backgroundColor: "#fcfafa", borderRadius: "10px", height: "12vh" }}>
                    <Grid container item xs={12} direction="column" style={{ justifyContent: "center", alignContent: "center", whiteSpace: "nowrap" }}>
                      <Grid container item xs={12} spacing={1} direction="column" alignItems="center">
                        <Grid item xs={1} sm={1} md={1} lg={1} xl={1} xxl={1} />
                        <Grid item xs={5} sm={5} md={5} lg={5} xl={5} xxl={5} className={classes.headingFont} style={{ display: "flex", justifyContent: "center" }}>
                          Power Consumption
                        </Grid>
                        <Grid container item xs={12}>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className={classes.statusFont} style={{ display: "flex", justifyContent: "center" }}>
                            <Success>{formatter.format(powerConsumption)}kWh</Success>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>

              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Grid>

      {/* ── Trend graphs ── */}
      <Grid container xs={12} spacing={2} style={{ marginTop: "0.5vh" }}>
        <Grid container item xs={12} spacing={1}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
            <Grid container spacing={1}>

              {/* Voltage */}
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                <Card className={classes.graphpaper}>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{ fontSize: "15px", color: "black", whiteSpace: "nowrap" }}><b>Voltage</b></Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                      {loading ? <div style={{ marginTop: "44px" }}>Loading...</div> : (
                        <TimeSeries1 data={graphData.llphase1} data2={graphData.llphase2} data3={graphData.llphase3} name="L-L Voltage[V]" />
                      )}
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              {/* Current */}
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                <Card className={classes.graphpaper}>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{ fontSize: "15px", color: "black", whiteSpace: "nowrap" }}><b>Current</b></Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                      {loading ? <div style={{ marginTop: "44px" }}>Loading...</div> : (
                        <TimeSeries1 data={graphData.currentphase1} data2={graphData.currentphase2} data3={graphData.currentphase3} name="Current[A]" />
                      )}
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              {/* Power Factor */}
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                <Card className={classes.graphpaper}>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{ fontSize: "15px", color: "black", whiteSpace: "nowrap" }}><b>Power Factor</b></Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                      {loading ? <div style={{ marginTop: "44px" }}>Loading...</div> : (
                        <TimeSeries1 data={graphData.powerfactorGraph} name="Power Factor[PF]" />
                      )}
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              {/* Load-KW */}
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                <Card className={classes.graphpaper}>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{ fontSize: "15px", color: "black", whiteSpace: "nowrap" }}><b>Load-KW</b></Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                      {loading ? <div style={{ marginTop: "44px" }}>Loading...</div> : (
                        <TimeSeries1 data={graphData.loadGraph} name="Load[kW]" />
                      )}
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              {/* Frequency */}
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                <Card className={classes.graphpaper}>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{ fontSize: "15px", color: "black", whiteSpace: "nowrap" }}><b>Frequency</b></Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                      {loading ? <div style={{ marginTop: "44px" }}>Loading...</div> : (
                        <TimeSeries1 data={graphData.freqGraph} name="Frequency[Hz]" />
                      )}
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              {/* Power Consumption */}
              <Grid item xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                <Card className={classes.graphpaper}>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{ fontSize: "15px", color: "black", whiteSpace: "nowrap" }}><b>Power Consumption</b></Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                      {loading ? <div style={{ marginTop: "44px" }}>Loading...</div> : (
                        <TimeSeries1 data={graphData.powerConsumptionGraph} name="Power Consumption[kWh]" />
                      )}
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default GlEnergyMeter;